export default "__VITE_ASSET__780bb354__"